import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const promotionsRoutes: RouteObject = {
  children: [
    {
      path: ROUTES.promotions.promotionsCnc,
      lazy: async () => {
        const { PromotionsCncPage } =
          await import('../../../pages/promotions/PromotionsCnc.page');

        return { Component: PromotionsCncPage };
      },
    },
    {
      path: ROUTES.promotions.promotionCnc,
      lazy: async () => {
        const { PromotionCncFormPage } =
          await import('../../../pages/promotions/PromotionCncForm.page');

        return { Component: PromotionCncFormPage };
      },
    },
    {
      path: ROUTES.promotions.promotionsCode,
      lazy: async () => {
        const { PromotionCodePage } =
          await import('../../../pages/promotions/PromotionCode.page');

        return { Component: PromotionCodePage };
      },
    },
    {
      path: ROUTES.promotions.promotionsProducts,
      lazy: async () => {
        const { PromotionCncProductsPage } =
          await import('../../../pages/promotions/PromotionCncProducts.page');

        return { Component: PromotionCncProductsPage };
      },
    },
    {
      path: ROUTES.promotions.promotionsSnC,
      lazy: async () => {
        const { PromotionsSnCPage } =
          await import('../../../pages/promotions/PromotionsSnC.page');

        return { Component: PromotionsSnCPage };
      },
    },
  ],
};
